import { NgClass } from "@angular/common";
import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
// Translate
import { TranslateModule, TranslateService } from "@ngx-translate/core";
// Project services
import { SessionDataService } from "../../../../../services/shared/SessionDataService.service";
// Components
import { WebCameraComponent } from "../../../../../global/web-camera/web-camera.component";
import { CodeScannerComponent } from "../../../../../global/code-scanner/code-scanner.component";
import { WebcamImage } from "ngx-webcam";

/**
 * Captures a meter activation photo or scans an activation field.
 * Dialog data selects the camera or scanner; results are returned through session component data.
 */
@Component({
  selector: "app-activation-modal",
  templateUrl: "./activation-modal.component.html",
  styleUrls: ["./activation-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CodeScannerComponent, WebCameraComponent, TranslateModule, NgClass]
})
export class ActivationModalComponent implements AfterContentInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  @Input() data: any;
  cameraHeight: number;
  cameraWidth: number;
  @ViewChild("activationModal") activationModal: ElementRef;
  @ViewChild("camera") camera: WebCameraComponent;
  @ViewChild("scanner") scanner: CodeScannerComponent;
  scannerZoomIn: boolean = false;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(
    public SessionDataService: SessionDataService,
    private readonly translate: TranslateService
  ) {}

  /***************************************************************************/
  // ANCHOR Render execution
  /***************************************************************************/

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.cameraHeight = this.activationModal.nativeElement.offsetHeight;
      this.cameraWidth = this.activationModal.nativeElement.offsetWidth;
    }, 0);
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  takePhoto(): void {
    this.camera.triggerSnapshot();
  }

  sendPhoto(photo: WebcamImage): void {
    this.SessionDataService.sendComponentData({ webcamImage: photo });
    this.SessionDataService.sendDialogAction({ action: "close" });
  }

  sendScanner(scannerResult: string): void {
    this.SessionDataService.sendComponentData({ scannerResult: scannerResult });
    this.SessionDataService.sendDialogAction({ action: "close" });
  }
}
